/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, lazy } from 'react'
import QRCode from 'react-qr-code'
import { getDataTicket } from '../../service/callAPI'

import { Box, Container, Link, Paper, Typography, Button, Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import LoadingThankyou from '../../components/LoadingThankyou'
const LogoBrand = lazy(() => import('../../components/LogoBrand'))

function Thankyou({ qrCode }) {
  const [data, setData] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))
  useEffect(() => {
    setIsLoading(true)
    getDataTicket({
      action: 'da999d7a-c164-a21a-bcf7-32cb27298727',
      actionType: 'check',
      code: qrCode,
      event_id: 'da999d7a-c164-a21a-bcf7-32cb27298727',
    }).then((res) => {
      // console.log('Thankyou', res)
      if (res.code === 0) {
        setData({
          code: res.data.VALIDATE_ACCOUNT_ID,
          name: `${res.data.FIRST_NAME} ${res.data.LAST_NAME}`,
          position: res.data.DATA_007,
        })
        setIsLoading(false)
      } else {
        setData({
          code: '',
          name: '',
          position: '',
        })
        setIsLoading(false)
      }
    })
  }, [])
  return (
    <div>
      <Box sx={{ backgroundColor: '#ffffff' }}>
        {/* <img src={window.location.origin + '/Main_Banner.jpg'} width="100%" alt="logo" /> */}
        <LogoBrand />
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center', backgroundColor: '#15261e' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#ffffff',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
            Thank you for completing your registration! <br /> We have reserved you a seat.
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            We look forward to welcoming you on Thursday, June 22, at the prestigious New World
            Makati Hotel. As you prepare for the event, we are delighted to provide your exclusive
            QR code.
          </Typography>
        </Box>
        {data.code && (
          <Box sx={{ mt: 2, mb: 2 }}>
            <QRCode
              value={data.code}
              size={232}
              style={{ border: '10px solid #FFF', borderRadius: '6px' }}
            />
          </Box>
        )}

        <Box sx={{ pb: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#ffffff',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
            {data.name}
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            {data.position}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            Please present this code during the registration process to check-in for the event on
            June 22, 2023.
          </Typography>
        </Box>
        <Box
          sx={{
            mt: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            Check out the State of HR 2023 Website PH website for more information on the event!
          </Typography>
        </Box>
        <Box>
          <Button
            component="a"
            href="https://events.sprout.ph/the-state-of-hr-2023"
            target="_blank"
            sx={{
              fontSize: matches && '1.175rem',
              // fontSize: '1.175rem',
              color: '#15261E',
              backgroundColor: '#e0c651',
              '&:hover': {
                color: '#15261E',
                backgroundColor: '#e0c651',
              },
            }}
          >
            Visit the State of HR Summit 2023 Website
          </Button>
        </Box>
        <Box
          sx={{
            pt: 2,
            pb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            As we countdown toward the most anticipated HR event, Take a moment to explore the event
            details, agenda, exceptional speakers, and important reminders provided below.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: '#15261e' }}>
        <img src={window.location.origin + '/Map.png'} width="100%" alt="logo" />
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center', backgroundColor: '#15261e' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#ffffff',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
             Available PAY Parking Spaces near New World Makati Hotel:
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: '#ffffff',
            }}
          >
            New World Makati Hotel Pay Parking - 200 PHP Net for 18 Hours <br /> Greenbelt 3 Parking
            - 2 min walk to the venue
          </Typography>
          <em style={{ color: '#ffffff' }}>
            For added convenience, New World Hotel Makati is offering a valet parking service at
            your disposal for a fee of 100 Pesos. 
          </em>
        </Box>
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="h3"
            sx={{
              color: '#15261e',
              fontSize: matches ? '1.95rem' : '1.38rem',
            }}
          >
            We've made it easier for you to block your calendars, <br /> just click on the links
            below:
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            color: '#02afce',
            fontSize: matches ? '24px' : '18px',
            mt: 4,
            mb: 4,
          }}
        >
          <Box
            component="a"
            href="https://calendar.google.com/calendar/render?action=TEMPLATE&amp;dates=20230622T000000Z%2F20230622T090000Z&amp;details=Hi%20There%2C%20%0A%0AThank%20you%20for%20registering%20for%20the%20State%20of%20HR%20Summit%202023%2C%20this%20year%27s%20most%20anticipated%20HR%20event%21%20%0A%0AReminders%3A%0AAddress%3A%20New%20World%20Hotel%20Makati%20-%20Esperanza%20street%20Corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%0AAttire%3A%20Smart%20Casual%0A%0ADon%27t%20forget%20to%20bring%20your%20business%20cards%20and%20your%20personalized%20QR%20codes%21%20%0A%0AAbout%20the%20Event%3A%20%0A%0AThe%20State%20of%20HR%20Summit%20is%20an%20annual%20event%20organized%20by%20Sprout%20Solutions.%20It%20presents%20the%20findings%20of%20our%20State%20of%20HR%202023%20research%2C%20uncovering%20key%20HR%20insights%20and%20trends.%20The%20report%20is%20based%20on%20workforce%20data%20and%20survey%20responses%20from%20400%20HR%20professionals%20and%20over%201%2C000%20employees.%20It%20highlights%20the%20importance%20of%20enhancing%20the%20employee%20experience%20for%20engagement%20and%20retention.%20Our%20aim%20for%20the%20summit%20is%20to%20offer%20guidance%20to%20organizations%20in%20the%20Philippines%2C%20helping%20them%20improve%20management%2C%20well-being%2C%20and%20retention%20strategies%20through%20digital%20transformation.%0A%0AFor%20any%20questions%2C%20you%20may%20email%20events%40sprout.ph.%20We%20can%27t%20wait%20to%20see%20you%20there%21%20&amp;location=New%20World%20Makati%20Hotel%2C%20corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%2C%20Philippines&amp;text=The%20State%20of%20HR%20Summit%202023"
            target="_blank"
            sx={{
              borderRight: '1px solid #02afce',
              pr: 0.5,
              textDecoration: 'underline',
              color: '#02afce',
            }}
          >
            Google Calendar
          </Box>
          <Box
            component="a"
            href="https://outlook.live.com/calendar/0/deeplink/compose?body=Hi%20There%2C%20%0A%0AThank%20you%20for%20registering%20for%20the%20State%20of%20HR%20Summit%202023%2C%20this%20year%27s%20most%20anticipated%20HR%20event%21%20%0A%0AReminders%3A%0AAddress%3A%20New%20World%20Hotel%20Makati%20-%20Esperanza%20street%20Corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%0AAttire%3A%20Smart%20Casual%0A%0ADon%27t%20forget%20to%20bring%20your%20business%20cards%20and%20your%20personalized%20QR%20codes%21%20%0A%0AAbout%20the%20Event%3A%20%0A%0AThe%20State%20of%20HR%20Summit%20is%20an%20annual%20event%20organized%20by%20Sprout%20Solutions.%20It%20presents%20the%20findings%20of%20our%20State%20of%20HR%202023%20research%2C%20uncovering%20key%20HR%20insights%20and%20trends.%20The%20report%20is%20based%20on%20workforce%20data%20and%20survey%20responses%20from%20400%20HR%20professionals%20and%20over%201%2C000%20employees.%20It%20highlights%20the%20importance%20of%20enhancing%20the%20employee%20experience%20for%20engagement%20and%20retention.%20Our%20aim%20for%20the%20summit%20is%20to%20offer%20guidance%20to%20organizations%20in%20the%20Philippines%2C%20helping%20them%20improve%20management%2C%20well-being%2C%20and%20retention%20strategies%20through%20digital%20transformation.%0A%0AFor%20any%20questions%2C%20you%20may%20email%20events%40sprout.ph.%20We%20can%27t%20wait%20to%20see%20you%20there%21%20&enddt=2023-06-22T09%3A00%3A00%2B00%3A00&location=New%20World%20Makati%20Hotel%2C%20corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%2C%20Philippines&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-06-22T00%3A00%3A00%2B00%3A00&subject=The%20State%20of%20HR%20Summit%202023"
            target="_blank"
            sx={{
              borderRight: '1px solid #02afce',
              borderLeft: '1px solid #02afce',
              pr: 0.5,
              pl: 0.5,
              textDecoration: 'underline',
              color: '#02afce',
            }}
          >
            Microsoft Outlook
          </Box>
          <Box
            component="a"
            href="https://outlook.office.com/calendar/0/deeplink/compose?body=Hi%20There%2C%20%0A%0AThank%20you%20for%20registering%20for%20the%20State%20of%20HR%20Summit%202023%2C%20this%20year%27s%20most%20anticipated%20HR%20event%21%20%0A%0AReminders%3A%0AAddress%3A%20New%20World%20Hotel%20Makati%20-%20Esperanza%20street%20Corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%0AAttire%3A%20Smart%20Casual%0A%0ADon%27t%20forget%20to%20bring%20your%20business%20cards%20and%20your%20personalized%20QR%20codes%21%20%0A%0AAbout%20the%20Event%3A%20%0A%0AThe%20State%20of%20HR%20Summit%20is%20an%20annual%20event%20organized%20by%20Sprout%20Solutions.%20It%20presents%20the%20findings%20of%20our%20State%20of%20HR%202023%20research%2C%20uncovering%20key%20HR%20insights%20and%20trends.%20The%20report%20is%20based%20on%20workforce%20data%20and%20survey%20responses%20from%20400%20HR%20professionals%20and%20over%201%2C000%20employees.%20It%20highlights%20the%20importance%20of%20enhancing%20the%20employee%20experience%20for%20engagement%20and%20retention.%20Our%20aim%20for%20the%20summit%20is%20to%20offer%20guidance%20to%20organizations%20in%20the%20Philippines%2C%20helping%20them%20improve%20management%2C%20well-being%2C%20and%20retention%20strategies%20through%20digital%20transformation.%0A%0AFor%20any%20questions%2C%20you%20may%20email%20events%40sprout.ph.%20We%20can%27t%20wait%20to%20see%20you%20there%21%20&enddt=2023-06-22T09%3A00%3A00%2B00%3A00&location=New%20World%20Makati%20Hotel%2C%20corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%2C%20Philippines&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2023-06-22T00%3A00%3A00%2B00%3A00&subject=The%20State%20of%20HR%20Summit%202023"
            target="_blank"
            sx={{
              borderRight: '1px solid #02afce',
              borderLeft: '1px solid #02afce',
              pr: 0.5,
              pl: 0.5,
              textDecoration: 'underline',
              color: '#02afce',
            }}
          >
            Microsoft 365
          </Box>
          <Box
            component="a"
            href="https://calendar.yahoo.com/?desc=Hi%20There%2C%20%0A%0AThank%20you%20for%20registering%20for%20the%20State%20of%20HR%20Summit%202023%2C%20this%20year%27s%20most%20anticipated%20HR%20event%21%20%0A%0AReminders%3A%0AAddress%3A%20New%20World%20Hotel%20Makati%20-%20Esperanza%20street%20Corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%0AAttire%3A%20Smart%20Casual%0A%0ADon%27t%20forget%20to%20bring%20your%20business%20cards%20and%20your%20personalized%20QR%20codes%21%20%0A%0AAbout%20the%20Event%3A%20%0A%0AThe%20State%20of%20HR%20Summit%20is%20an%20annual%20event%20organized%20by%20Sprout%20Solutions.%20It%20presents%20the%20findings%20of%20our%20State%20of%20HR%202023%20research%2C%20uncovering%20key%20HR%20insights%20and%20trends.%20The%20report%20is%20based%20on%20workforce%20data%20and%20survey%20responses%20from%20400%20HR%20professionals%20and%20over%201%2C000%20employees.%20It%20highlights%20the%20importance%20of%20enhancing%20the%20employee%20experience%20for%20engagement%20and%20retention.%20Our%20aim%20for%20the%20summit%20is%20to%20offer%20guidance%20to%20organizations%20in%20the%20Philippines%2C%20helping%20them%20improve%20management%2C%20well-being%2C%20and%20retention%20strategies%20through%20digital%20transformation.%0A%0AFor%20any%20questions%2C%20you%20may%20email%20events%40sprout.ph.%20We%20can%27t%20wait%20to%20see%20you%20there%21%20&et=20230622T090000Z&in_loc=New%20World%20Makati%20Hotel%2C%20corner%20Makati%20Avenue%2C%20Ayala%20Center%2C%20Esperanza%20St%2C%20Makati%2C%201228%20Metro%20Manila%2C%20Philippines&st=20230622T000000Z&title=The%20State%20of%20HR%20Summit%202023&v=60"
            target="_blank"
            sx={{
              borderLeft: '1px solid #02afce',
              pl: 0.5,
              textDecoration: 'underline',
              color: '#02afce',
            }}
          >
            Yahoo Calendar
          </Box>
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: '#15261e',
              mb: 2,
            }}
          >
            Feel free to add the event to your calendar so you don't miss out!
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="h6"
            sx={{
              color: '#15261e',
              mb: 2,
            }}
          >
            For any inquiries and feedback, reply to events@sporut.ph. See you soon!
          </Typography>
        </Box>
      </Box>
      <Box sx={{ pl: '20px', pr: '20px', textAlign: 'center', backgroundColor: '#15261e' }}>
        <Box sx={{ pb: 2, pt: 2 }}>
          <Typography
            variant="p"
            sx={{
              color: '#ffffff',
            }}
          >
            Sprout Solutions, 9th floor Unit D, Rockwell Business Center Sheridan North Tower,
            Sheridan St. cor United St., <br /> Mandaluyong City, Metro Manila 1554, Philippines,
            02-3485-8338 / 02-8779-6542
          </Typography>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: '#15261e' }}>
        <img src={window.location.origin + '/Sponsor_logos.png'} width="100%" alt="logo" />
      </Box>
    </div>
  )
}

export default Thankyou
